module.exports = __webpack_public_path__ + "5305010974fac7314d896985bdb8f9ee.MP3";